import clsx from "clsx";
import React from "react";
import { Button, BoxProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ChevronDownIcon as ArrowDropDown } from "lucide-react";

import { ActivitySort, activitySortOptions } from "../../constants";
import { DropdownMenu } from "../menu/DropdownMenu";

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 15,
  },

  active: {
    color: theme.palette.primary.main,
  },

  inactive: {
    color: theme.palette.text.secondary,
  },
}));

export interface ActivitySortFilterProps extends Omit<BoxProps, "onChange"> {
  sortedBy: ActivitySort;
  active?: boolean;
  onChange: (sortedBy: ActivitySort) => void;
}

export function ActivitySortFilter(props: ActivitySortFilterProps) {
  const { className, sortedBy, active, onChange, ...other } = props;
  const s = useStyles();
  const ref = React.useRef<HTMLElement>();

  const triggerGenerator = (bindTrigger, menuState) => (
    <Button
      className={clsx(s.root, active ? s.active : s.inactive, className)}
      ref={ref}
      {...bindTrigger(menuState)}
      {...other}
    >
      Sort by: {activitySortOptions[sortedBy]}
      <ArrowDropDown size={20} style={{ marginLeft: 2 }} />
    </Button>
  );

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
      const {
        currentTarget: {
          dataset: { sortBy },
        },
      } = event;

      onChange(sortBy as ActivitySort);
    },
    [onChange],
  );

  const items = React.useMemo(
    () =>
      Object.entries(activitySortOptions).map(([sortBy, label]) => ({
        children: label,
        onClick: handleClick,
        data: { "sort-by": sortBy },
        selected: sortBy === sortedBy,
      })),
    [handleClick, sortedBy],
  );

  return (
    <DropdownMenu
      menuId="select-progress-period"
      items={items}
      triggerGenerator={triggerGenerator}
    />
  );
}
